import { CircularProgress, Dialog, DialogContent, Grid } from "@mui/material";
import { getLoaderCount } from "@slices/loaderSlice";
import { useAppSelector } from "@store/hooks";

const Loader = () => {
    const loaderCount: number = useAppSelector(getLoaderCount).value;

    return (
        <Dialog open={Boolean(loaderCount)}>
            <DialogContent>
                <Grid container>
                    <Grid item>
                        <CircularProgress color="primary" />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default Loader;
